import SvgIcon from 'bee-svgicon'

export default SvgIcon
